export default class Notifications {
	constructor(timeout = 10000) {
		this.timeout = timeout;
		this.msgs = [];
		this.handlers = {};
	}

	get(i) {
		return this.msgs[i];
	}

	// mensagens registadas para o proximo Messages (React)
	register(msgs) {
		this.msgs_reg = msgs;
	}

	flush() {
		if (this.msgs_reg) {
			this.set(this.msgs_reg);
			this.msgs_reg = undefined;
		}
		return this.msgs;
	}

	set(msgs) {
		this.msgs = msgs;
		this.raiseEvents();
		for (let i = 0, l = msgs.length; i < l; i ++) {
			this.setTimeout(msgs[i]);
		}
	}

	add(m) {
		this.msgs.push(m);
		this.raiseEvents();
		this.setTimeout(m);
	}

	setTimeout(msg) {
		const _msg = typeof msg.msg === 'string' ? msg : msg.msg;

		if (_msg.timeout === undefined || _msg.timeout > 0) {
			msg.handlerTimeout = setTimeout( () => {
					this.remove(msg);
				},
				_msg.timeout || this.timeout
			);
		}
	}

	remove(msg, contains = false) {
		for (let i in this.msgs) {
			if (this.msgs[i] === msg || (contains && this.msgs[i].msg.indexOf(msg) >= 0)) {
				if (this.msgs[i].handlerTimeout) {
					clearTimeout(this.msgs[i].handlerTimeout);
				}
				this.msgs.splice(i, 1);
				this.raiseEvents();
				break;
			}
		}
	}

	clear(raiseEvents = true) {
		this.msgs = [];
		if (raiseEvents) {
			this.raiseEvents();
		}
	}

	addHandler(handler) {
		let idx = Object.keys(this.handlers).length;

		this.handlers[idx] = handler;
		return idx;
	}

	removeHandler(handlerIdx) {
		if (this.handlers.hasOwnProperty(handlerIdx)) {
			delete this.handlers[handlerIdx];
		}
	}

	raiseEvents() {
		for (let i in this.handlers) {
			this.handlers[i](this.msgs);
		}
	}
}
